<template>
  <header class="subHeader">
    <div class="content-header">REVIEW</div>
    <div class="content-body">Events ADURO has sent for approval.</div>
  </header>
</template>
<script>
export default {
  name: 'subHeaderReview',
  methods: {
    sidebarToggle (e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    }
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// SubHeaderReview.vue?5b73428c